var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('multiselect',{attrs:{"show-labels":false,"placeholder":"Verpackungen auswählen","options":_vm.allpackages,"multiple":true,"track-by":"id","label":"displayedZohoCode","close-on-select":true},model:{value:(_vm.mutableSelectedPackages),callback:function ($$v) {_vm.mutableSelectedPackages=$$v},expression:"mutableSelectedPackages"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }